module.exports = __webpack_public_path__ + "img/tip.525cdfb0.png";